import { Button, TextField, View, Image } from '@aws-amplify/ui-react';
import { CircularProgress, Grid } from '@mui/material';
import { verifyMFACode } from 'client/clients';
import { useState } from 'react';
import utkashLogo from '../../assets/utkarsh-logo1.png';
import reactangleLogo from '../../assets/rectangle.png';
import { Auth } from 'aws-amplify';
import AWS from 'aws-sdk';
import { useDispatch } from 'react-redux';
import { SET_LOGIN_AUTH, SET_OPEN_MFA } from 'store/actions';

export default function VerifyMFA({ user, signature }) {
    const clientId = process.env.REACT_APP_CLIENT_ID;
    const [code, setCode] = useState('');
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const [errorMessage, setErrorMessage] = useState({
        code: '',
        message: '',
        type: null
    });

    const onChange = (e) => {
        setCode(e.target.value);
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        if (code.length === 6) {
            const payload = {
                signature,
                otp: code,
                username: user.username,
                clientId: clientId
            };
            await verifyMFACode(payload)
                .then((res) => {
                    const token = res?.accessToken;
                    sessionStorage.setItem('accessToken', token);
                    sessionStorage.setItem('refreshToken', res?.refreshToken);

                    dispatch({ type: SET_LOGIN_AUTH, isAutherized: true });

                    // getUserAttributesFromAccessToken(token);

                    getUserAttributesFromAccessToken(token).then((attributes) => {
                        if (attributes) {
                            const documentID = attributes['custom:documentID'];

                            if (documentID) {
                                sessionStorage.setItem('documentID', documentID);
                                dispatch({ type: SET_OPEN_MFA, openApp: true });
                            }
                        } else {
                            setErrorMessage((prev) => ({
                                ...prev,
                                message: 'Failed to fetch user attributes.'
                            }));
                        }
                    });
                })
                .catch((e) => {
                    setErrorMessage((prev) => ({
                        ...prev,
                        message: e?.response?.data?.msg || 'Unkown error occured'
                    }));
                });
        } else {
            setErrorMessage((prev) => ({ ...prev, message: 'OTP must be 6 digits' }));
        }

        setLoading(false);
    };

    const cognitoISP = new AWS.CognitoIdentityServiceProvider({
        region: 'ap-south-1' // Set your region
    });

    const getUserAttributesFromAccessToken = async (accessToken) => {
        if (!accessToken) {
            setErrorMessage((prev) => ({
                ...prev,
                message: 'Access token is missing.'
            }));
            return null;
        }

        try {
            const response = await cognitoISP.getUser({ AccessToken: accessToken }).promise();

            const attributes = {};
            response.UserAttributes.forEach((attr) => {
                attributes[attr.Name] = attr.Value;
            });

            return attributes;
        } catch (error) {
            if (error.code === 'NotAuthorizedException') {
                setErrorMessage((prev) => ({
                    ...prev,
                    message: 'Access token is invalid or revoked. User must login again.'
                }));
            } else if (error.code === 'ResourceNotFoundException') {
                setErrorMessage((prev) => ({
                    ...prev,
                    message: 'User not found.'
                }));
            } else if (error.code === 'InvalidParameterException') {
                setErrorMessage((prev) => ({
                    ...prev,
                    message: 'Invalid parameters in the request.'
                }));
            } else if (error.code === 'TokenExpiredException') {
                setErrorMessage((prev) => ({
                    ...prev,
                    message: 'Access token has expired.'
                }));
            } else {
                setErrorMessage((prev) => ({
                    ...prev,
                    message: 'Unknown error occurred.'
                }));
            }

            return null;
        }
    };

    return (
        <Grid container item justifyContent="center" alignItems="center" direction="row" alignContent="center" className="Login_container">
            <Grid item className="Login_box" direction="column">
                <View textAlign="center" className="logo">
                    <div className="utkasrhlogo-container" style={{ backgroundImage: `url(${reactangleLogo})` }}>
                        <Image
                            src={utkashLogo}
                            alt="logo"
                            style={{ width: '100%', height: '100%', padding: '10px 10px 5px 10px', backgroundColor: '#dcd3e4' }}
                        />
                    </div>
                </View>
                <form onChange={onChange} onSubmit={onSubmit}>
                    <View className="Login_siginIn">
                        <div>
                            <center>
                                <p>
                                    <b>Verify OTP</b>
                                </p>
                            </center>
                        </div>

                        <div item container className="Forgot_label_MFA">
                            {/* <center>Please Enter the code sent to your mail id</center> */}
                            <p className="otp-info-text">
                                We've sent a verification code to your &nbsp;
                                <strong>Email Id</strong>
                            </p>
                        </div>

                        <Grid item container className="Login_pwd_container">
                            <TextField
                                label="Code"
                                value={code}
                                className="Login_input"
                                autoComplete={false}
                                name="code"
                                type="number"
                                required
                                maxLength={6}
                            />
                        </Grid>
                        <Grid>
                            <center>
                                <p style={{ color: 'red' }}>{errorMessage.message}</p>
                            </center>
                        </Grid>

                        <Grid item container className="" style={{ paddingTop: '15px' }}>
                            <Button type="submit" className={loading ? 'Login_signIn_Loading' : 'Login_signIn'}>
                                {loading ? (
                                    <>
                                        <CircularProgress size={15} color="inherit" /> &nbsp;
                                        <span>Confirm</span>
                                    </>
                                ) : (
                                    'Confirm'
                                )}
                            </Button>
                        </Grid>

                        <Grid item container direction="row" justifyContent="center" className="Login_signInContainer">
                            <label
                                onClick={() => {
                                    window.location.reload();
                                }}
                                className="Login_forgot_pwd"
                            >
                                Back To Sign In
                            </label>
                        </Grid>
                    </View>
                </form>
            </Grid>
        </Grid>
    );
}
